import { useEffect, useState } from 'react';
import { WaveService } from '../utility';

export const WaveRulesMetadataHook = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await WaveService.rulesMetadata();
      setData(res);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, loading, error, refresh: fetchData };
};

export const waveRuleAutocompleteHook = (warehouseId, search) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);

      const temp = {
        search,
        warehouseId,
      };

      if (temp.search) {
        temp.search = temp.search.trim();
      }

      const res = await WaveService.waveRuleList(temp);
      const mapped = res?.rules.map(d => ({ ...d, search }));
      setData(mapped);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!warehouseId) {
      return;
    }

    setData([]);
    fetchData();
  }, [search, warehouseId]);

  return { data, error, loading };
};
